import React from "react";

/**
 * Regulens brand mark — the lens-convergence icon.
 *
 * Two overlapping circles converging on a single gold focus point.
 * Colors flow from CSS variables (`--rg-sage`, `--rg-gold`) so the
 * mark automatically flips with light/dark theme + palette changes.
 *
 * Variants:
 *   - "full"    → nav bars, admin headers, hero. Thin sage strokes.
 *   - "favicon" → 16px use. Bolder sage strokes, larger gold.
 *
 * `theme` prop still accepted for backward-compat but is now a no-op
 * because CSS vars carry the theme. Kept so existing callers don't break.
 */
export function RegulensMark({
  size = 32,
  variant = "full",
  className,
  strokeWidth,
  ...rest
}) {
  // Geometry per variant — see file header for rationale.
  const geo =
    variant === "favicon"
      ? { r: 7, cxL: 12, cxR: 20, gold: 3, stroke: 3.6 }
      : { r: 8.5, cxL: 11, cxR: 21, gold: 2.6, stroke: 2.4 };
  const s = strokeWidth ?? geo.stroke;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role="img"
      aria-label="Regulens"
      className={className}
      {...rest}
    >
      <circle cx={geo.cxL} cy="16" r={geo.r} fill="none" stroke="var(--rg-sage)" strokeWidth={s} />
      <circle cx={geo.cxR} cy="16" r={geo.r} fill="none" stroke="var(--rg-sage)" strokeWidth={s} />
      <circle cx="16" cy="16" r={geo.gold} fill="var(--rg-gold)" />
    </svg>
  );
}

export default RegulensMark;
